import styled from "styled-components";
import { transition } from "styles/utils";

export const Overlay = styled.div<{ height?: string }>`
    position: relative;
    width: 100%;
    height: ${({ height = "inherit" }) => height};
    min-height: 100%;
`;

export const LoaderContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 11;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const LoaderBackdrop = styled.div<{ active: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    background-color: ${({ active }) => (active ? "white" : "transparent")};
    z-index: 10;

    ${transition(0.5)}
`;
